import React, { forwardRef } from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';

// Get Material-UI selected class to show
// via https://github.com/mui-org/material-ui/issues/1534#issuecomment-629548123
const NavigationLink = forwardRef((props, ref) => {
  const handleClick = e => {
    if (props.disabled) e.preventDefault();
    if (props.onClick) props.onClick();
  };

  // Allows passing in isActive prop in route config files
  const isActive = props.isActive
    ? (match, location) => props.isActive({ match, location })
    : match => match;

  return <RouterNavLink {...props} isActive={isActive} onClick={handleClick} ref={ref} />;
});

export default NavigationLink;
